export default __webpack_public_path__ + "static/media/OVIT.9e291e7a.png";